import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

import { signInWithGoogle, signInWithFacebook } from '../firebase/socialAuth';
import { GoogleIcon, FacebookIcon } from './icons/SocialIcons';

interface SocialLoginButtonsProps {
    onProviderSelect: (signIn: () => Promise<string>) => void;
}

export default function SocialLoginButtons({ onProviderSelect }: SocialLoginButtonsProps) {
    const { t } = useTranslation();

    return (
        <>
            <Grid item xs={12}>
                <Button
                id="google-login-btn"
                variant="outlined"
                fullWidth
                startIcon={<GoogleIcon />}
                onClick={() => onProviderSelect(signInWithGoogle)}
                sx={{
                    color: 'rgba(0, 0, 0, 0.87)',
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                    backgroundColor: '#fff',
                    textTransform: 'none',
                    '&:hover': { borderColor: 'rgba(0, 0, 0, 0.4)', backgroundColor: 'rgba(0, 0, 0, 0.02)' },
                }}
                >
                {t('login.continueWithGoogle')}
                </Button>
            </Grid>
            <Grid item xs={12}>
                <Button
                id="facebook-login-btn"
                variant="contained"
                fullWidth
                startIcon={<FacebookIcon />}
                onClick={() => onProviderSelect(signInWithFacebook)}
                sx={{
                    color: '#fff',
                    backgroundColor: '#1877F2',
                    textTransform: 'none',
                    '&:hover': { backgroundColor: '#0f63d1' },
                }}
                >
                {t('login.continueWithFacebook')}
                </Button>
            </Grid>
        </>
    );
}
